import React from 'react';
import { FormInstance } from 'antd';
import {
  WorksListItemShortTypesType,
  WorksListItemLongTypesType,
  worksListItemLongToShortTypeMap,
} from '@onboarding/services';
import { ComplianceItemType } from '@onboarding/graphql';
import { ComplianceItemAddAttachmentFormIdDoc } from './_compliance-item-add-attachment-form-id-doc';
import { ComplianceItemAddAttachmentFormCertification } from './_compliance-item-add-attachment-form-certification';
import { ComplianceItemAddAttachmentFormLicense } from './_compliance-item-add-attachment-form-license';
import { ComplianceItemAddAttachmentFormAssessment } from './_compliance-item-add-attachment-form-assessment';
import { ComplianceItemAddAttachmentFormImmigration } from './_compliance-item-add-attachment-form-immigration';
import { ComplianceItemAddAttachmentFormOtherDoc } from './_compliance-item-add-attachment-form-other-doc';
import { ComplianceItemAddAttachmentFormHealthDoc } from './_compliance-item-add-attachment-form-health-doc';
import { ComplianceItemAddAttachmentFormIdDocWithAi } from './_compliance-item-add-attachment-form-id-doc-with-ai';

type Props = {
  form: FormInstance;
  complianceItem: ComplianceItemType;
  refetchQueries: string[];
  onSubmit?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
};

function getShortType(longType: WorksListItemLongTypesType | undefined) {
  return longType ? worksListItemLongToShortTypeMap[longType] : '';
}

export function ComplianceItemAddAttachmentForm({
  form,
  complianceItem,
  refetchQueries,
  onSubmit,
  onSuccess,
  onError,
}: Props) {
  const isDriversLicenseType =
    complianceItem.documentTemplate?.key === 'identity/drivers_license';

  const formList = {
    assessment: ComplianceItemAddAttachmentFormAssessment,
    certification: ComplianceItemAddAttachmentFormCertification,
    health_doc: ComplianceItemAddAttachmentFormHealthDoc,
    identification: isDriversLicenseType
      ? ComplianceItemAddAttachmentFormIdDocWithAi
      : ComplianceItemAddAttachmentFormIdDoc,
    immigration: ComplianceItemAddAttachmentFormImmigration,
    license: ComplianceItemAddAttachmentFormLicense,
    other_doc: ComplianceItemAddAttachmentFormOtherDoc,
  };

  const shortType = getShortType(complianceItem.type);
  const SpecificForm = formList[shortType as WorksListItemShortTypesType];

  return (
    <SpecificForm
      form={form}
      complianceItem={complianceItem}
      refetchQueries={refetchQueries}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
}
